export default "__VITE_ASSET__BqVieZks__"